import { Plugin } from '@ckeditor/ckeditor5-core/src';
import { Typing } from '@ckeditor/ckeditor5-typing/src';

/**
 * Converting <code> blocks without required by CKEditor <pre> block. Only needed for content created prior to CKEditor.
 */
export default class EmptyBreak extends Plugin {

    /**
	 * @inheritDoc
	 */
	static get requires() {
		return [ Typing ];
	}

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'EmptyBreak';
	}

	/**
	 * @inheritDoc
	 */
	constructor( editor ) {
		super( editor );
	}

    /**
	 * @inheritDoc
	 */
    init() {
		const editor = this.editor;
		
		editor.model.schema.register( 'noBreak', {
			allowWhere: '$block',
			isBlock: false,
		});

        editor.conversion.for( 'upcast' ).elementToElement( {
			model: ( viewElement, modelWriter ) => {

				if(viewElement.nextSibling === null && viewElement.previousSibling !== null) {
					modelWriter.consumable.consume( viewElement, { name: true } );
				}
				return null;
			},
			converterPriority: 'highest',
			view: 'br'
		} );
    }
}